/** Initials for an avatar: from the name, else from the email's local part (`dana.lee@` -> DL). */
export function userInitials(name?: string | null, email?: string | null) {
  const source = name?.trim() || email?.trim().split('@')[0] || '';
  const words = source.split(/[\s._-]+/).filter(Boolean);
  if (words.length === 0) {
    return '';
  }
  if (words.length === 1) {
    return words[0].substring(0, 2).toUpperCase();
  }
  return `${words[0][0]}${words[words.length - 1][0]}`.toUpperCase();
}
